import { handleActions } from 'redux-actions';

import { constants as orderConstants } from 'utils/order';

import reducersUtils from 'state/utils';

import actions from 'state/order/actionCreators';
import initialState from 'state/order/initial.state';

const orderReducer = handleActions(
  {
    [reducersUtils.RESET_ORDER_STATE]: () => initialState,
    [actions.setType]: (state, { payload: { type } }) => ({
      ...state,
      type,
    }),
    [actions.setRecurring]: (state, { payload: { isRecurring } }) => ({
      ...state,
      isRecurring,
      type: isRecurring ? orderConstants.DIRECT_ORDER : state.type,
      maximumOfItemsInLoads: {},
    }),
    [actions.setMaximums]: (state, { payload: { maximums } }) => ({
      ...state,
      maximumOfItemsInLoads: maximums,
    }),
    [actions.setMaxItemsInLoad]: (state, { payload: { max } }) => ({
      ...state,
      maxNumberOfItems: max,
    }),
    [actions.setMaxReached]: (state, { payload: { reached } }) => ({
      ...state,
      maxReached: reached,
    }),
    [actions.setPaymentIntentSecret]: (
      state,
      { payload: { paymentIntentSecret } }
    ) => ({
      ...state,
      paymentIntentSecret,
    }),
    [actions.setLastId]: (state, { payload: { lastId } }) => ({
      ...state,
      lastId,
    }),
    [actions.cleanRepeatAndEditing]: (state) => ({
      ...state,
      isEditing: false,
    }),
    [actions.setHolidays]: (
      state,
      { payload: { holidays, stopType, shipmentKey } }
    ) => ({
      ...state,
      holidays: {
        ...state.holidays,
        [shipmentKey]: {
          ...state.holidays[shipmentKey],
          [stopType]: holidays,
        },
      },
    }),
    [actions.setValidations]: (state, { payload: { validations } }) => ({
      ...state,
      validations,
    }),
    [actions.setShipperQuoteId]: (state, { payload: { shipperQuoteId } }) => ({
      ...state,
      shipperQuoteId,
    }),
    [actions.setEditing]: (
      state,
      { payload: { isEditing, type, originalPrice, originalId } }
    ) => ({
      ...state,
      isEditing,
      originalPrice,
      type,
      originalId,
      maximumOfItemsInLoads: {},
    }),
    [actions.setQuoteSuggestions]: (
      state,
      { payload: { quoteSuggestions } }
    ) => ({
      ...state,
      quoteSuggestions,
    }),
    [actions.cleanQuoteSuggestions]: (state) => ({
      ...state,
      quoteSuggestions: [],
    }),
    [actions.setTimeWindows]: (state, { payload: { timeWindows } }) => ({
      ...state,
      timeWindows,
    }),
    [actions.cleanTimeWindows]: (state) => ({
      ...state,
      timeWindows: [],
    }),
    [actions.setTimeWindowsRequestPayload]: (
      state,
      { payload: { timeWindowsRequestPayload } }
    ) => ({
      ...state,
      timeWindowsRequestPayload,
    }),
    [actions.disableEconomyMode]: (state) => ({
      ...state,
      isEconomyModeEnabled: false,
    }),
    [actions.enableEconomyMode]: (state) => ({
      ...state,
      isEconomyModeEnabled: true,
    }),
  },
  initialState
);

export default orderReducer;
